module.exports = __webpack_public_path__ + "img/labels-3-d-mobile-fr.1c417ca1.webp";